module.exports = __webpack_public_path__ + "static/media/01-leaving-ny.79ac5f8b.jpg";